"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinalizationPlugin = void 0;
const common_1 = require("../common");
const BasePlugin_1 = require("./BasePlugin");
class FinalizationPlugin extends BasePlugin_1.BasePlugin {
  execute(list, _activities, _groups, _conditions, _selected) {
    return list.map(this._addRenderAs);
  }
  _addRenderAs = item => {
    // set renderas according to disabled & registered generated by plugins
    if (this._isOpenForSelect(item)) {
      // when places_left it means we have infinite slots
      if (item.places_left === null || item.places_left > 0) {
        item['renderas'] = common_1.RenderAs.Open;
      } else if (item.waitinglist) {
        item['renderas'] = common_1.RenderAs.OpenWaitingList;
      } else {
        item['renderas'] = common_1.RenderAs.Disabled;
      }
    } else if (this._isDisabled(item)) {
      item['renderas'] = common_1.RenderAs.Disabled;
    }
    const aps = item.activity_participant_status;
    // these statues are immutatable.
    if (aps === common_1.ActivityParticipantStatus.PAYMENT_IN_PROGRESS) {
      item.renderas = common_1.RenderAs.PaymentInProgress;
      return item;
    }
    if (aps === common_1.ActivityParticipantStatus.REGISTRATION_IN_PROGRESS) {
      item.renderas = common_1.RenderAs.RegistrationInProgress;
      return item;
    }
    if (aps === common_1.ActivityParticipantStatus.APPROVAL_PENDING) {
      item.renderas = common_1.RenderAs.ApprovalPending;
      return item;
    }
    if (aps === common_1.ActivityParticipantStatus.ARRIVED) {
      item.renderas = common_1.RenderAs.Arrived;
      return item;
    }
    if (aps === common_1.ActivityParticipantStatus.NO_SHOW) {
      item.renderas = common_1.RenderAs.NoShow;
      return item;
    }
    // now state of activity_participant_status can overrule renderas
    if (item.registered && aps === common_1.ActivityParticipantStatus.WAITING_LIST) {
      item['renderas'] = common_1.RenderAs.WaitingList;
      return item;
    }
    // now state of activity_participant_status can overrule renderas
    if (item.registered && aps === common_1.ActivityParticipantStatus.REGISTERED) {
      item['renderas'] = common_1.RenderAs.Registered;
      return item;
    }
    // only REGISTERED & WAITING_LIST activity_participant_status can overrule not NEW
    // so if it's disabled we won't touch it here
    if (item.registered && !item.disabled && aps === common_1.ActivityParticipantStatus.NEW) {
      if (item.approval) {
        item['renderas'] = common_1.RenderAs.ApprovalPending;
      } else if (item.places_left === null || item.places_left > 0) {
        // when places_left it means we have infinite slots
        item['renderas'] = common_1.RenderAs.Registered;
      } else if (item.waitinglist) {
        item['renderas'] = common_1.RenderAs.WaitingList;
      } else {
        item['renderas'] = common_1.RenderAs.Disabled;
      }
      return item;
    }
    if (!item['renderas']) {
      item['renderas'] = common_1.RenderAs.Disabled;
    }
    return item;
  };
}
exports.FinalizationPlugin = FinalizationPlugin;
